<template>
    <v-dialog v-model="dialog" persistent width="1000">
        <v-card tile class="pa-6">
            <h6 class="text-h6 pa-4">Вручить документ потребителю</h6>
            <v-divider />
            <v-card
                flat
                tile
                :color="step === 1 ? '#6B7BB2' : ''"
                :class="step === 1 ? 'white--text' : ''"
                max-width="128"
                class="pa-4 font-weight-bold d-inline-block"
            >
                Шаг 1<br />
                Заполнение
            </v-card>
            <v-card
                v-if="canSign"
                :color="step === 2 ? '#6B7BB2' : ''"
                flat
                tile
                max-width="130"
                :class="step === 2 ? 'white--text' : ''"
                class="pa-4 font-weight-bold d-inline-block"
            >
                Шаг 2<br />Подписание
            </v-card>
            <div v-if="step === 1">
                <v-card color="#F2C94C" tile class="d-flex align-start mt-4 py-6 px-4">
                    <v-icon color="black" class="pt-1">priority_high</v-icon>
                    <p class="text-subtitle-1 mb-0 black--text">
                        Настоящее досудебное уведомление является предупреждением о прекращении (ограничении) поставки горячего водоснабжения и отопления, в
                        случае неисполнения обязательств по погашению задолженности, по истечении
                        {{ this.isContract ? '3 (трех)' : '30 (тридцати)' }} календарных дней момента его вручения.
                    </p>
                </v-card>
                <div class="pa-4">
                    <v-row>
                        <v-col cols="4" class="shallowGray--text">Номер документа</v-col>
                        <v-col class="black--text">{{ details.doc_number }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="shallowGray--text">{{ serialNumberLabel }}</v-col>
                        <v-col class="black--text">{{ details.serial_number }}</v-col>
                    </v-row>
                    <v-row v-if="details['open_date']">
                        <v-col cols="4" class="shallowGray--text">Дата заключения договора</v-col>
                        <v-col class="black--text">{{ details['open_date'] }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="shallowGray--text">{{ nameLabel }}</v-col>
                        <v-col class="black--text">{{ details.name }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="shallowGray--text">Адрес</v-col>
                        <v-col class="black--text">{{ details.address_full_name }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="shallowGray--text">Сумма задолженности</v-col>
                        <v-col class="black--text">{{ details.sum_debt }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="shallowGray--text">ФИО Инженера</v-col>
                        <v-col class="black--text">{{ details.engineer_name }}</v-col>
                    </v-row>
                </div>
                <v-form ref="form" @submit.prevent="submit">
                    <div class="pa-4">
                        <v-row>
                            <v-col cols="4">
                                <PreTrialDatePicker :disabled="true" :date.sync="form.doc_delivery_date" label="Дата вручения документа" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    :disabled="!details['is_editable']"
                                    v-model="form.receiver_name"
                                    hide-details="auto"
                                    outlined
                                    color="gray"
                                    label="ФИО получателя"
                                    :rules="[validationRules.required]"
                                    validate-on-blur
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="isContract">
                            <v-col>
                                <v-autocomplete
                                    :disabled="!details['is_editable']"
                                    v-model="form.job_position_type_rid"
                                    hide-details="auto"
                                    outlined
                                    color="gray"
                                    label="Должность"
                                    :items="jobPositionTypes"
                                    item-text="job_pos_type_name"
                                    item-value="record_id"
                                    clearable
                                    :filter="prefixFilter"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="isContract">
                            <v-col>
                                <v-checkbox
                                    :disabled="!details['is_editable']"
                                    v-model="form.abonent_was_not"
                                    hide-details="auto"
                                    outlined
                                    color="gray"
                                    label="Абонента не было"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    :disabled="!details['is_editable']"
                                    v-maska:[maskaOptions]="phone"
                                    v-model="form.contacts_receiver"
                                    hide-details="auto"
                                    outlined
                                    :rules="[validationRules.phone]"
                                    color="gray"
                                    placeholder="+7 (XXX) XXX XX XX"
                                    label="Контактный номер телефона получателя"
                                    validate-on-blur
                                />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    :disabled="!details['is_editable']"
                                    v-model="form.e_mail"
                                    hide-details="auto"
                                    type="email"
                                    :rules="[validationRules.email]"
                                    outlined
                                    color="gray"
                                    placeholder="name@gmail.com"
                                    label="E-mail"
                                    validate-on-blur
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    :disabled="!details['is_editable']"
                                    v-model="form.comment"
                                    hide-details="auto"
                                    outlined
                                    color="gray"
                                    label="Комментарий"
                                    placeholder="Введите комментарий если это необходимо"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <UploadDocuments :uploadedFiles.sync="files" />
                    <div style="gap: 16px" class="pt-10 pb-4 px-4 d-flex justify-end">
                        <v-btn @click="closeDialog" color="gray" rounded outlined class="text-uppercase">отмена</v-btn>
                        <v-btn @click="saveDocument" color="gray" rounded outlined class="text-uppercase">Сохранить без подписи</v-btn>
                        <v-btn v-if="canSign" type="submit" color="gray white--text" rounded class="text-uppercase">подписать</v-btn>
                    </div>
                </v-form>
            </div>
            <SignStep @goToPreviousStep="goToPreviousStep" @cancel="closeDialog" :is-contract="isContract" v-else :details="details" />
        </v-card>
    </v-dialog>
</template>

<script>
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import UploadDocuments from '@/components/ui/UploadDocuments.vue';
import { validationRules } from '@/utils/validationRules';
import FileService from '@/services/apiRequests/file.service';
import { mapActions, mapGetters } from 'vuex';
import SignStep from '@/components/pre-trial-notices/SignStep.vue';
import { mask } from '@/main';
import { maskaOptions } from '@/utils';
import translate from '@/utils/translate.util';

export default {
    name: 'PreTrialDetails',
    components: { SignStep, UploadDocuments, PreTrialDatePicker },
    props: {
        details: {
            required: true
        },
        isContract: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialog: false,
            number: null,
            form: {
                comment: '',
                doc_delivery_date: '',
                receiver_name: '',
                e_mail: '',
                id: null,
                contacts_receiver: '',
                job_position_type_rid: null,
                abonent_was_not: false
            },
            phone: {
                masked: '',
                unmasked: '',
                completed: false
            },
            files: [],
            step: 1,
            maskaOptions: maskaOptions(this)
        };
    },
    computed: {
        ...mapGetters('auth', ['hasPermissionTo']),
        ...mapGetters('refs', ['getJobPositionTypes']),
        validationRules() {
            return validationRules;
        },
        serialNumberLabel() {
            return this.isContract ? 'Номер договора' : 'Номер лицевого счета';
        },
        nameLabel() {
            return this.isContract ? 'Контрагент' : 'ФИО собственника';
        },
        canSign() {
            return this.hasPermissionTo('sign_document');
        },
        jobPositionTypes() {
            return translate(this.getJobPositionTypes, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapActions('base', ['showMessage']),
        showDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.files = [];
            this.step = 1;
            this.form = {
                comment: '',
                doc_delivery_date: '',
                receiver_name: '',
                e_mail: '',
                id: null,
                job_position_type_rid: null,
                abonent_was_not: false
            };
            this.$refs.form.resetValidation();
        },
        prepareFormToSend() {
            if (!this.$refs.form.validate()) return false;
            this.form.id = this.details.id;
            this.form.contacts_receiver = this.phone.masked;
            return true;
        },
        saveDocument() {
            if (!this.prepareFormToSend()) {
                return;
            }
            if (!this.files.length) {
                this.showMessage({ message: 'Выберите хотя бы один файл', color: 'error' });
                return;
            }
            this.$emit('saveDocument', { form: this.form, files: this.files });
        },
        submit() {
            if (!this.prepareFormToSend()) {
                return;
            }
            this.$emit('submit', { form: this.form, files: this.files, completeSubmit: this.onCompleteSubmit });
        },
        onCompleteSubmit() {
            this.step = 2;
        },
        goToPreviousStep() {
            this.step = 1;
        },
        prefixFilter(item, queryText, itemText) {
            if (!queryText) return true;
            return itemText.toLowerCase().startsWith(queryText.toLowerCase());
        }
    },
    watch: {
        async details() {
            Object.keys(this.details).forEach(key => {
                if (key in this.form) {
                    this.form[key] = this.details[key];
                }
            });

            const response = await FileService.getFilesList(this.details.guid);
            if (response.data) {
                const apiCallPromises = response.data.map(file => FileService.getFile(file.attachment_link_rid));
                const result = await Promise.all(apiCallPromises);
                result.forEach(file => {
                    let preview;
                    if (file.data['attach_file_type'] === 'application/pdf') {
                        preview = 'pdf';
                    } else {
                        preview = `data:${file.data['attach_file_type']};base64,${file.data['attach_file']}`;
                    }

                    this.files.push({ preview, isDeletable: false });
                });
            }
        },
        step() {
            //to avoid bug with mask when moving between steps
            if (this.details.contacts_receiver) {
                this.form.contacts_receiver = mask.unmasked(this.details.contacts_receiver);
            }
        },
        dialog(newvalue, oldvalue) {
            if (!newvalue && oldvalue) this.$emit('applyFilter');
        }
    }
};
</script>

<style scoped></style>
